// Production configuration
// This file handles environment-specific settings

const config = {
  // API base URL - automatically detects environment
  API_BASE_URL: process.env.NODE_ENV === 'production'
    ? '/api'  // Production: relative path to backend
    : 'http://localhost:5000/api',  // Development: localhost

  // Upload URL for file viewing
  UPLOAD_BASE_URL: process.env.NODE_ENV === 'production'
    ? '/uploads'  // Production: relative path
    : 'http://localhost:5000/uploads',  // Development: localhost

  // Environment
  NODE_ENV: process.env.NODE_ENV || 'development'
};

export default config;